export const GetWindParkSelect = "GetWindParkSelect";
export const SetCurrentPark = "SetCurrentPark";
